import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { TYPE_GENERIC, TYPE_GENERIC_BUSINESS, INFO, SIGNIN } from '../config';
import { BUSINESS, USER } from '../../../constants/QMTypes';

import SelectionButton from '../components/SelectionButton';
import ContactUs from '../components/ContactUs';

import containerStyles from './Select.scss';

const businessArray = [
  {
    text: 'Create a New Business Account',
    image: 'static/webBeta/art-new-business.png',
    route: INFO,
  },
  {
    text: 'Sign into Existing Business Account',
    image: 'static/webBeta/art-signin-business.png',
    route: SIGNIN,
  },
];

const propertyArray = [
  {
    text: "I'm a homeowner",
    image: 'static/webBeta/homeowner.png',
    type: TYPE_GENERIC,
  },
  {
    text: "I'm a local business",
    image: 'static/webBeta/business.png',
    type: TYPE_GENERIC_BUSINESS,
  },
];

export default class Select extends Component {
  static propTypes = {
    setType: PropTypes.func,
    selectType: PropTypes.oneOf([BUSINESS, USER]).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    setType: null,
  };

  navigateType = (e, item) => {
    e.preventDefault();
    const { setType, history } = this.props;
    if (item.type && setType) {
      setType(item.type);
    } else {
      history.push(item.route);
    }
  };

  navigateBusiness = e => {
    e.preventDefault();
    const { setType } = this.props;
    setType(TYPE_GENERIC_BUSINESS);
  };

  render() {
    const { selectType } = this.props;
    const useArray = selectType === BUSINESS ? businessArray : propertyArray;
    return (
      <div className={containerStyles.container}>
        <div
          className={containerStyles.selectContainer}
          style={{ marginBottom: selectType === BUSINESS ? 0 : 70 }}
        >
          {useArray.map(item => (
            <SelectionButton
              key={item.text}
              image={item.image}
              text={item.text}
              style={{ marginBottom: 16 }}
              onClick={e => this.navigateType(e, item)}
            />
          ))}
        </div>
        {selectType === BUSINESS && <ContactUs />}
      </div>
    );
  }
}
